module.exports = __webpack_public_path__ + "static/media/input.dfdcfe62.svg";